import { render, staticRenderFns } from "./Indice.vue?vue&type=template&id=0be054ee&scoped=true"
import script from "./Indice.vue?vue&type=script&lang=js"
export * from "./Indice.vue?vue&type=script&lang=js"
import style0 from "./Indice.vue?vue&type=style&index=0&id=0be054ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be054ee",
  null
  
)

export default component.exports